<template>
  <div
    class="option-value"
    :class="{ disabled: value.Disabled, selected: (value.Id == selectedValueId) }"
    @click="onClick(value.Id, $event)"
    @mouseover="onMouseover(value.Name)"
    @mouseleave="onMouseleave"
  >
    <div v-if="showPhotos" class="option-value-image-container">
      <img class="option-value-image" :src="value.PhotoUrl" />
    </div>
    <div class="option-value-name-container">
      <p class="option-value-name">{{value.Name}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "showPhotos", "selectedValueId"],
  methods: {
    onClick: function(valueId, event) {
      this.$emit("value-click", valueId, event);
    },
    onMouseover: function(valueName) {
      this.$emit("value-mouseover", valueName);
    },
    onMouseleave: function() {
      this.$emit("value-mouseleave");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
